export default __webpack_public_path__ + "static/media/papers_white.eb457577.svg";